export const EXTERNAL_URLS = {
  getCountryFlagUrl: (countryCode: string) => `https://flagcdn.com/${countryCode}.svg`,
};
